/**
 * Returns the highest roles name for a user, excluding superadmin.
 */
export function getHighestRoleName(roles: string[]) {
  if (roles.includes('superadmin')) {
    return 'Superadmin'
  } else if (roles.includes('support')) {
    return 'Support'
  } else if (roles.includes('corporate')) {
    return 'Corporate'
  } else if (roles.includes('admin')) {
    return 'Admin'
  } else if (roles.includes('sales')) {
    return 'Sales'
  } else if (roles.includes('crew')) {
    return 'Crew'
  } else if (roles.includes('viewer')) {
    return 'Office'
  }
}
